export const TASK_PRIORITIES_RADIO_ICONS = [
    { id: 1, className: 'error'},
    { id: 2, className: 'warning'},
    { id: 3, className: 'success'}
];

export const TASK_PRIORITIES = {
    1: 'error',
    2: 'warning',
    3: 'success'
};

export const PERIODS = {
    DAY: 'DAY',
    WEEK5: 'WEEK5',
    WEEK7: 'WEEK7'
};

export const periodConfig = {
    [PERIODS.DAY]: {
        days: 1,
        getFromToObj: (date) => ({
            dateFrom: date,
            dateTo: null
        })
    },
    [PERIODS.WEEK5]: {
        days: 7,
        getFromToObj: (date) => ({
            dateFrom: date.clone().startOf('week'),
            dateTo: date.day() === 0 ? date.clone().day(-2) : date.clone().day(5)
        })
    },
    [PERIODS.WEEK7]: {
        days: 7,
        getFromToObj: (date) => ({
            dateFrom: date.clone().startOf('week'),
            dateTo: date.clone().endOf('week')
        })
    }
};

export const CALENDAR_FILTERS = {
    SOTRMEET: 'sotrmeet',
    PRIVATE: 'private',
    TELCNT: 'telcnt',
    MEETINGS: 'meetings'
};
